export default __webpack_public_path__ + "static/photoelectric1-f9af5c180e4933ded05571028854329c.png";